module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('form-input', [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label ? _vm.label : _vm.$t("pos.comment.write")))]), _c('markdown', {
    staticClass: "rules",
    attrs: {
      "source": _vm.$t('pos.comment.rules.text')
    }
  })], 1), _c('b-form-textarea', {
    attrs: {
      "slot": "input",
      "rows": 3,
      "placeholder": _vm.placeholder ? _vm.placeholder : _vm.$t("pos.comment.leave-a-comment"),
      "data-test": "comment-text"
    },
    slot: "input",
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('file-upload', {
    ref: "upload",
    staticClass: "mb-3",
    attrs: {
      "files": _vm.files,
      "data-test": "comment-fileupload",
      "rules": _vm.$t("pos.comment.rules.file-upload")
    },
    on: {
      "update:files": function($event) {
        _vm.files = $event
      }
    }
  })], 1), _c('div', {
    staticClass: "col-lg-4"
  }, [(!this.$slots["buttons"]) ? _c('div', {
    staticClass: "text-right"
  }, [_c('b-btn', {
    attrs: {
      "disabled": !_vm.text,
      "data-test": "comment-submit"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])], 1) : _vm._e(), _vm._t("buttons")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7931856d"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/comment/Comment.vue
// module id = 2066
// module chunks = 1